import { css } from "@emotion/css";
import HistoryBet from "components/history-bet/HistoryBet";
import LiveItemMobile from "components/live-item-mobile";
import Modal from "components/modal/Modal";
import { GameInstance, GameInstanceHistory, GameInstanceHistoryOddEven, TabGameItem, UserInfo } from "models/gameModel";
import React, { useState } from "react";

interface Props {
	balance: number;
	tabGame: TabGameItem[];
	tabActive: TabGameItem;
	onChangeTab: (tab: TabGameItem) => void;
	gamesActive: GameInstance[];
	gameAll: GameInstance[];
	historyIssue: GameInstanceHistory;
	totalOddEven: GameInstanceHistoryOddEven;
	launchGame: (gameId: number) => void;
	onGoBack: () => void;
}
export default function BoardMobile(props: Props) {
	const { balance, tabGame, tabActive, onChangeTab, gamesActive, gameAll, historyIssue, totalOddEven, launchGame, onGoBack } = props;
	const [showHistory, setShowHistory] = useState(false);

	return (
		<>
			<div className={styles.wrap}>
				<div className="header">
					<div className="header-left">
						<button type="button" className="btn-back" onClick={onGoBack}>
							<img src={require("assets/images/icons/icon-arrow.png")} alt="" />
						</button>
						<img className="logo" src={require("assets/images/logo.png")} alt="" />
					</div>
					<div className="header-right">
						<div className="balance">
							<img src={require("assets/images/icon-money.png")} alt="" />
							<span>{new Intl.NumberFormat().format(balance || 0)}</span>
						</div>
						<div className="btn-history" onClick={() => setShowHistory(true)}>
							<img src={require("assets/images/icons/icon-history-m.png")} alt="" />
						</div>
					</div>
				</div>
				<div className={styles.gameBoy}>
					<div className="game-menu">
						{tabGame.map((tab) => (
							<React.Fragment key={tab.value}>
								<div className={tabActive.value === tab.value ? "menu-item active" : "menu-item"} onClick={() => onChangeTab(tab)}>
									<div className="menu-icon">
										<img src={tab.icon} alt="" />
									</div>
									<p>{tab.label}</p>
									{!tab.isReady && <div className="label-comming">COMING SOON</div>}
								</div>
								<div className="line"></div>
							</React.Fragment>
						))}
					</div>
					<div className="game-list">
						{gamesActive.map((game) => (
							<LiveItemMobile
								key={game.id}
								gameInstance={game}
								historyData={historyIssue[game.id]}
								statsTotal={totalOddEven[game.id]}
								onPlayGame={launchGame}
								typeGame={tabActive.path}
							/>
						))}
					</div>
				</div>
			</div>
			<Modal isShow={showHistory} onClose={() => setShowHistory(false)} width="90%" maxWidth="500px">
				<HistoryBet gameList={gameAll} liveGameId={tabActive.value} onClose={() => setShowHistory(false)} />
			</Modal>
		</>
	);
}

const styles = {
	wrap: css`
		height: 100%;
		position: relative;
		overflow-x: hidden;
		background: #080b21;
		width: 100%;
		max-width: 500px;
		margin: 0 auto;
		display: flex;
		flex-direction: column;
		.header {
			display: flex;
			align-items: center;
			justify-content: space-between;
			border-bottom: 1px solid #e28800;
			padding: 8px 12px;
			.btn-back {
				padding: 4px;
				width: 28px;
				height: 28px;
				img {
					width: 100%;
					height: 100%;
					object-fit: contain;
				}
			}
			.header-left {
				display: flex;
				align-items: center;
				gap: 8px;
				.logo {
					width: 120px;
				}
			}
			.header-right {
				display: flex;
				align-items: center;
				gap: 10px;
				> div {
					background: #263457;
					border-radius: 6px;
					align-self: stretch;
					padding: 4px;
				}
				.btn-history {
					width: 32px;
					height: 32px;
					img {
						width: 22px;
					}
				}
				.balance {
					display: flex;
					align-items: center;
					gap: 4px;
					padding: 4px 8px;
					img {
						width: 18px;
					}
					span {
						font-size: 14px;
					}
				}
			}
		}
	`,
	gameBoy: css`
		flex: 1;
		display: flex;
		max-height: calc(100% - 49px);
		.game-menu {
			flex: 0 0 72px;
			max-width: 72px;
			padding: 12px 5px;
			display: flex;
			flex-direction: column;
			gap: 12px;
			.menu-item {
				padding: 6px;
				display: flex;
				flex-direction: column;
				align-items: center;
				border: 1px solid transparent;
				position: relative;
				&.active {
					border-color: #7087bf;
					border-radius: 8px;
					background: #263457;
				}
				.menu-icon {
					width: 36px;
					height: 36px;
					display: flex;
					align-items: center;
					justify-content: center;
					padding: 4px;
					img {
						width: 100%;
						height: 100%;
						object-fit: contain;
					}
				}
				.label-comming {
					position: absolute;
					top: -4px;
					left: 10%;
					width: 80%;
					background: linear-gradient(180deg, rgba(11, 117, 121, 1) 0%, rgba(2, 46, 42, 1) 100%);
					font-size: 8px;
					padding: 2px 4px;
					text-align: center;
					border-radius: 4px;
				}
				p {
					font-size: 11px;
				}
			}
			.line {
				width: 80%;
				margin: 0 auto;
				height: 1px;
				background: #272c49;
				&:last-child {
					display: none;
				}
			}
		}
		.game-list {
			flex: 1;
			height: 100%;
			overflow-y: auto;
			background: #263457;
			padding: 4px;
			padding-top: 6px;
		}
	`,
};
